function deepFreeze<T>(object: T): T {
  Object.freeze(object);
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const value = object[key];
      if (typeof value === 'object' && value instanceof Object && !Object.isFrozen(value)) {
        deepFreeze(value);
      }
    }
  }
  return object;
}

export default deepFreeze;
